export default __webpack_public_path__ + "static/media/front-thumb.e6ba94f0.jpg";